module.exports = __webpack_public_path__ + "static/portfoliobg-46649122f72061813b158dcd502884ce.jpg";